import styles from "../aic.module.css";
import { AioLabel } from "./aioLabel";

interface AioBooleanProps {
  id: string;
  value: boolean;
  label?: string;
  setValue: (value: boolean) => void;
  disabled?: boolean;
}

/**
 * Boolean input component with label.
 *
 * @param props - Destructured parameter object
 * @param props.id - The id for the control
 * @param props.value - The current boolean value
 * @param props.label - Optional label for the input
 * @param props.setValue - Function to update the boolean value
 * @param props.disabled - If true, the input is disabled
 */
export const AioBoolean = (props: AioBooleanProps): React.ReactElement => {
  return (
    <>
      <AioLabel
        id={`${props.id}-label`}
        label={props.label}
      />
      <div className={styles.aioInputHolder}>
        <input
          id={props.id}
          aria-labelledby={`${props.id}-label`}
          checked={props.value}
          disabled={!(typeof props.setValue === "function") || props.disabled}
          onChange={(e) => props.setValue(e.currentTarget.checked)}
          type={"checkbox"}
        />
      </div>
    </>
  );
};

AioBoolean.displayName = "AioBoolean";
